"use strict";

module.exports = {
  PHONE_NUMBER: '(###) ###-####',
  EMAIL: 'example@gmail.com'
};